import { c as _c } from "react/compiler-runtime";
import { Card } from '@/components/ui/card';
import { cn } from '@/utils/tailwindcss-override';
import type React from 'react';

/** A grey bar where text will be; it pulses only for those who did not ask for less motion. */
export const SkeletonBar: React.FC<{
  className?: string;
}> = t0 => {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("bg-quiet block rounded-md motion-safe:animate-pulse", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span aria-hidden="true" className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
const SkeletonRow: React.FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SkeletonBar className="h-[38px] w-[38px] shrink-0 rounded-[10px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <li className="flex items-start gap-4 px-4 py-4 sm:px-5">{t0}<span className="flex flex-1 flex-col gap-2 pt-0.5"><SkeletonBar className="h-4 w-1/2" /><SkeletonBar className="h-3 w-1/3" /><SkeletonBar className="h-3 w-5/6" /></span></li>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};

/** The result list while the results of the current query are on their way. */
export const ResultListSkeleton: React.FC<{
  rows?: number;
  className?: string;
}> = t0 => {
  const $ = _c(7);
  const {
    rows: t1,
    className
  } = t0;
  const rows = t1 === undefined ? 4 : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn(className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== rows) {
    t3 = Array.from({
      length: rows
    }, _temp);
    $[2] = rows;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <Card as="ul" divided={true} className={t2}>{t3}</Card>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};

/** The preview beside the list while its result is on its way. */
export const PreviewSkeleton: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-3"><SkeletonBar className="h-4 w-24" /><SkeletonBar className="mt-2 h-7 w-2/3" /><SkeletonBar className="mt-2 h-16 w-full rounded-[14px]" /><SkeletonBar className="mt-3 h-3 w-28" /><SkeletonBar className="h-3 w-full" /><SkeletonBar className="h-3 w-5/6" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};

/** The rows of the instant search while its results are on their way. */
export const InstantRowsSkeleton: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-1.5 px-3 py-3"><SkeletonBar className="mx-1 mb-1.5 h-3 w-20" />{Array.from({
        length: 4
      }, _temp2)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(_, index) {
  return <SkeletonRow key={index} />;
}
function _temp2(_, index) {
  return <div key={index} className="bg-quiet/60 flex min-h-14 items-center gap-3 rounded-[10px] px-3"><SkeletonBar className="h-9 w-9 shrink-0 rounded-[9px] bg-white" /><span className="flex flex-1 flex-col gap-1.5"><SkeletonBar className="h-3.5 w-2/3 bg-white" /><SkeletonBar className="h-3 w-1/3 bg-white" /></span></div>;
}